import { lazyWithRetry } from '@util/lazyWithRetry';

// dashbaord
const Dashboard = lazyWithRetry(() => import('../components/dashboard'));

//user
const UserList = lazyWithRetry(() => import('@pages/merchant/user/userList'));
const UserEnroll = lazyWithRetry(() => import('@pages/user/userEnroll'));

// pages
const ProductList = lazyWithRetry(() => import('@pages/merchant/product/productList'));
const TicketList = lazyWithRetry(() => import('@pages/merchant/ticket/TicketList'));
const SeatInfo = lazyWithRetry(() => import('@pages/merchant/seat/seatInfo'));
const SeatList = lazyWithRetry(() => import('@pages/merchant/seat/seatList'));
const Setting = lazyWithRetry(() => import('@pages/merchant/hardware/setting'));
const PaylogInfo = lazyWithRetry(() => import('@pages/merchant/payment/paylogInfo'));

const MessageInfo = lazyWithRetry(() => import('@pages/merchant/message/messageInfo'));
const OpsBriefingDetail = lazyWithRetry(() => import('@pages/merchant/ops/OpsBriefingDetail'));

const storeSetting = lazyWithRetry(() => import('@pages/merchant/hardware/merchantSetting'));
const SeatChange = lazyWithRetry(() => import('@pages/merchant/seat/seatChange'));
const LockerChange = lazyWithRetry(() => import('@pages/merchant/seat/lockerChange'));
const Seminar = lazyWithRetry(() => import('@pages/merchant/seminar/seminarReservationV2'));
const SeminarInfo = lazyWithRetry(() => import('@pages/merchant/seminar/seminarInfo'));
const Mileage = lazyWithRetry(() => import('@pages/merchant/mileage/mileage'));
const Coupon = lazyWithRetry(() => import('@pages/merchant/coupon/coupon'));
const SignUp = lazyWithRetry(() => import('../auth/signup'));

const Vending = lazyWithRetry(() => import('@pages/merchant/product/vending'));
const Kiosk_setting = lazyWithRetry(() => import('@pages/merchant/hardware/kiosk_setting'));
const ExitLog = lazyWithRetry(() => import('@pages/merchant/seat/ExitLog'));
const UserTicketInfo = lazyWithRetry(() => import('@pages/user/userTicketInfo'));
const UserTicketBuy = lazyWithRetry(() => import('@pages/user/userTicketBuy'));
const UserInfo = lazyWithRetry(() => import('@pages/user/UserInfo'));

const UserPaymentInfo = lazyWithRetry(() => import('@pages/user/paymentInfo'));
const UserSeminarInfo = lazyWithRetry(() => import('@pages/user/seminarInfo'));
const UserSeminarBuy = lazyWithRetry(() => import('@pages/user/seminarBuy'));
const UserMileage = lazyWithRetry(() => import('@pages/user/mileage'));
const Usercoupon = lazyWithRetry(() => import('@pages/user/coupon'));
const UserSeatList = lazyWithRetry(() => import('@pages/user/UserSeatList'));
const User = lazyWithRetry(() => import('@pages/user/user'));

const Success = lazyWithRetry(() => import('@pages/user/success'));
const AdminDashboard = lazyWithRetry(() => import('../components/dashboard/admin'));
const FindPassword = lazyWithRetry(() => import('../auth/password'));
const ImageSetting = lazyWithRetry(() => import('@pages/merchant/hardware/BannerImageSetting'));

//이용약관 - terms
const InformationAgreement = lazyWithRetry(() => import('@pages/terms/informationAgreement'));
const MarketingAgreement = lazyWithRetry(() => import('@pages/terms/marketingAgreement'));
const ServiceRule = lazyWithRetry(() => import('@pages/terms/serviceRule'));
const UseRule = lazyWithRetry(() => import('@pages/terms/useRule'));
const MessageCharge = lazyWithRetry(() => import('@pages/merchant/message/messageCharge'));
const MessageChargeList = lazyWithRetry(() => import('@pages/merchant/message/messageChargeList'));
const SalesDay = lazyWithRetry(() => import('@pages/merchant/sales/SalesDay'));
const SalesMonth = lazyWithRetry(() => import('@pages/merchant/sales/SalesMonth'));
const MessageSuccess = lazyWithRetry(() => import('@pages/merchant/message/messageSuccess'));
const FailPayment = lazyWithRetry(() => import('@pages/user/failPayment'));
const MessageFail = lazyWithRetry(() => import('@pages/merchant/message/messageFail'));
const PaymentSetting = lazyWithRetry(() => import('@pages/merchant/hardware/PaymentSetting'));
const WebReceipt = lazyWithRetry(() => import('@pages/external/webReceipt'));
const SeatCategory = lazyWithRetry(() => import('@pages/merchant/seat/SeatCategory'));
const SelectMerchant = lazyWithRetry(() => import('@pages/user/SelectMerchant'));
const PaymentResult = lazyWithRetry(() => import('@pages/user/PaymentResult'));
const LockerChangeV2 = lazyWithRetry(() => import('@pages/merchant/seat/LockerChangeV2'));
const SeatChangeV2 = lazyWithRetry(() => import('@pages/merchant/seat/SeatChangeV2'));
const MessageSendV2 = lazyWithRetry(() => import('@pages/merchant/message/MessageSendV2'));
const MessageBulkV2 = lazyWithRetry(() => import('@pages/merchant/message/MessageBulkV2'));
const CouponV2 = lazyWithRetry(() => import('@pages/merchant/coupon/CouponV2'));
const Error429 = lazyWithRetry(() => import('@pages/errors/Error429'));
const WebCall = lazyWithRetry(() => import('@pages/external/WebCall'));
const AppMerchantInfo = lazyWithRetry(() => import('@pages/merchant/app/AppMerchantInfo'));
const AppReviewManage = lazyWithRetry(() => import('@pages/merchant/app/AppReviewManage'));
const BackofficeSelectMerchant = lazyWithRetry(
  () => import('@pages/backoffice/merchant/BackofficeSelectMerchant'),
);
const BackofficeChangePassword = lazyWithRetry(() => import('@pages/backoffice/BackofficeChangePassword'));
const BackofficeMerchantSales = lazyWithRetry(
  () => import('@pages/backoffice/sales/BackofficeMerchantSales'),
);
const BackofficeFranchise = lazyWithRetry(() => import('@pages/backoffice/sales/BackofficeFranchise'));
const BackofficeChargeMessagePoint = lazyWithRetry(
  () => import('@pages/backoffice/message/BackofficeChargeMessagePoint'),
);
const BackofficeKioskBanner = lazyWithRetry(() => import('@pages/backoffice/kiosk/BackofficeKioskBanner'));
const BackofficeNotice = lazyWithRetry(() => import('@pages/backoffice/merchant/BackofficeNotice'));
const BackofficeMerchantOpinion = lazyWithRetry(
  () => import('@pages/backoffice/merchant/BackofficeMerchantOpinion'),
);
const BackofficeIssueCoupon = lazyWithRetry(() => import('@pages/backoffice/coupon/BackofficeIssueCoupon'));
const BackofficeChargeMessagePointHistory = lazyWithRetry(
  () => import('@pages/backoffice/message/BackofficeChargeMessagePointHistory'),
);
const BackofficeUpdateKiosk = lazyWithRetry(() => import('@pages/backoffice/kiosk/BackofficeUpdateKiosk'));
const BackofficeKioskVersion = lazyWithRetry(() => import('@pages/backoffice/kiosk/BackofficeKioskVersion'));
const BackofficeCommunityManage = lazyWithRetry(
  () => import('@pages/backoffice/community/BackofficeCommunityManage'),
);
const BackofficeCommunityPostDetail = lazyWithRetry(
  () => import('@pages/backoffice/community/BackofficeCommunityPostDetail'),
);
const AppCommunityManage = lazyWithRetry(() => import('@pages/merchant/app/AppCommunityManage'));
const AppCommunityPostDetail = lazyWithRetry(() => import('@pages/merchant/app/AppCommunityPostDetail'));
const UserLockerBuy = lazyWithRetry(() => import('@pages/user/UserLockerBuy'));
const BackofficeCreateMerchant = lazyWithRetry(
  () => import('@pages/backoffice/merchant/BackofficeCreateMerchant'),
);
const BackofficeMerchantDetail = lazyWithRetry(
  () => import('@pages/backoffice/merchant/BackofficeMerchantDetail'),
);
const BackofficeUserManagement = lazyWithRetry(
  () => import('@pages/backoffice/user/BackofficeUserManagement'),
);
const BackofficeAppBannerManage = lazyWithRetry(
  () => import('@pages/backoffice/app/BackofficeAppBannerManage'),
);
const AppBannerManage = lazyWithRetry(() => import('@pages/merchant/app/AppBannerManage'));
const BackofficeAppReviewTagManage = lazyWithRetry(
  () => import('@pages/backoffice/app/BackofficeAppReviewTagManage'),
);
const BackofficeAppServiceTagManage = lazyWithRetry(
  () => import('@pages/backoffice/app/BackofficeAppServiceTagManage'),
);
const BackofficeUserWithdrawal = lazyWithRetry(
  () => import('@pages/backoffice/user/BackofficeUserWithdrawal'),
);
const BackofficeKioskDevice = lazyWithRetry(() => import('@pages/backoffice/kiosk/BackofficeKioskDevice'));
const BackofficePaymentManage = lazyWithRetry(
  () => import('@pages/backoffice/sales/BackofficePaymentManage'),
);
const BackofficePGConfig = lazyWithRetry(
  () => import('@pages/backoffice/merchant/BackofficePGConfig'),
);
// const Lab = lazyWithRetry(() => import('@pages/common/Lab'));

export const backofficeRoute = [
  {
    path: '/backoffice/merchant/list',
    Component: BackofficeSelectMerchant,
  },
  {
    path: '/backoffice/merchant/detail',
    Component: BackofficeMerchantDetail,
  },
  {
    path: '/backoffice/merchant/create',
    Component: BackofficeCreateMerchant,
  },
  {
    path: '/backoffice/merchant/notice',
    Component: BackofficeNotice,
  },
  {
    path: '/backoffice/merchant/opinion',
    Component: BackofficeMerchantOpinion,
  },
  {
    path: '/backoffice/merchant/pg-config',
    Component: BackofficePGConfig,
  },
  {
    path: '/backoffice/user/phone',
    Component: BackofficeUserManagement,
  },
  {
    path: '/backoffice/user/withdrawal',
    Component: BackofficeUserWithdrawal,
  },
  {
    path: '/backoffice/change-password',
    Component: BackofficeChangePassword,
  },
  {
    path: '/backoffice/sales/merchant',
    Component: BackofficeMerchantSales,
  },
  {
    path: '/backoffice/sales/franchise',
    Component: BackofficeFranchise,
  },
  {
    path: '/backoffice/message/charge',
    Component: BackofficeChargeMessagePoint,
  },
  {
    path: '/backoffice/kiosk/banner',
    Component: BackofficeKioskBanner,
  },
  {
    path: '/backoffice/coupon/issue',
    Component: BackofficeIssueCoupon,
  },
  {
    path: '/backoffice/message/history',
    Component: BackofficeChargeMessagePointHistory,
  },
  {
    path: '/backoffice/kiosk/update',
    Component: BackofficeUpdateKiosk,
  },
  {
    path: '/backoffice/kiosk/version',
    Component: BackofficeKioskVersion,
  },
  {
    path: '/backoffice/app/community',
    Component: BackofficeCommunityManage,
  },
  {
    path: '/backoffice/app/community/:communityPostId',
    Component: BackofficeCommunityPostDetail,
  },
  {
    path: '/backoffice/app/banner',
    Component: BackofficeAppBannerManage,
  },

  {
    path: '/backoffice/app/review/tag',
    Component: BackofficeAppReviewTagManage,
  },
  {
    path: '/backoffice/app/service/tag',
    Component: BackofficeAppServiceTagManage,
  },
  {
    path: '/backoffice/kiosk/device',
    Component: BackofficeKioskDevice,
  },
  {
    path: '/backoffice/sales/payment',
    Component: BackofficePaymentManage,
  },
  // {
  //   path: '/backoffice/lab',
  //   Component: Lab,
  // },
];

export const routes = [
  {
    path: `${process.env.PUBLIC_URL}/admin/dashboard`,
    Component: AdminDashboard,
  },
  {
    path: `${process.env.PUBLIC_URL}/admin/ops-briefing`,
    Component: OpsBriefingDetail,
  },
  {
    path: `${process.env.PUBLIC_URL}/web-call/:uuid`,
    Component: WebCall,
  },
  { path: `${process.env.PUBLIC_URL}/user/userlist`, Component: UserList },
  { path: `${process.env.PUBLIC_URL}/user/userEnroll`, Component: UserEnroll },
  {
    path: `${process.env.PUBLIC_URL}/auth/join`,
    Component: SignUp,
  },
  {
    path: `${process.env.PUBLIC_URL}/auth/password`,
    Component: FindPassword,
  },

  {
    path: `${process.env.PUBLIC_URL}/product/product-list`,
    Component: ProductList,
  },
  {
    path: `${process.env.PUBLIC_URL}/product/vending`,
    Component: Vending,
  },
  {
    path: `${process.env.PUBLIC_URL}/ticket/ticket-list`,
    Component: TicketList,
  },
  {
    path: `${process.env.PUBLIC_URL}/seat/info`,
    Component: SeatInfo,
  },
  {
    path: `${process.env.PUBLIC_URL}/seat/list`,
    Component: SeatList,
  },
  {
    path: `${process.env.PUBLIC_URL}/setting/default-setting`,
    Component: Setting,
  },
  {
    path: `${process.env.PUBLIC_URL}/setting/store-setting`,
    Component: storeSetting,
  },
  {
    path: `${process.env.PUBLIC_URL}/setting/payment-setting`,
    Component: PaymentSetting,
  },
  {
    path: `${process.env.PUBLIC_URL}/pay/info`,
    Component: PaylogInfo,
  },
  {
    path: `${process.env.PUBLIC_URL}/message/info`,
    Component: MessageInfo,
  },
  {
    path: `${process.env.PUBLIC_URL}/message/send`,
    Component: MessageSendV2,
  },
  {
    path: `${process.env.PUBLIC_URL}/message/bulk`,
    Component: MessageBulkV2,
  },
  {
    path: `${process.env.PUBLIC_URL}/message/charge`,
    Component: MessageCharge,
  },
  {
    path: `${process.env.PUBLIC_URL}/message/charge-list`,
    Component: MessageChargeList,
  },
  // {
  //   path: `${process.env.PUBLIC_URL}/seat/change`,
  //   Component: SeatChange,
  // },
  // {
  //   path: `${process.env.PUBLIC_URL}/locker/change`,
  //   Component: LockerChange,
  // },
  // {
  //   path: `${process.env.PUBLIC_URL}/seat/category`,
  //   Component: SeatCategory,
  // },
  {
    path: `${process.env.PUBLIC_URL}/seminar/reservation`,
    Component: Seminar,
  },
  {
    path: `${process.env.PUBLIC_URL}/seminar/info`,
    Component: SeminarInfo,
  },
  {
    path: `${process.env.PUBLIC_URL}/mileage`,
    Component: Mileage,
  },

  {
    path: `${process.env.PUBLIC_URL}/setting/kiosk-setting`,
    Component: Kiosk_setting,
  },
  {
    path: `${process.env.PUBLIC_URL}/exit-data`,
    Component: ExitLog,
  },
  {
    path: `${process.env.PUBLIC_URL}/setting/image-setting`,
    Component: ImageSetting,
  },

  {
    path: `${process.env.PUBLIC_URL}/success`,
    Component: Success,
  },

  {
    path: `${process.env.PUBLIC_URL}/admin/success`,
    Component: MessageSuccess,
  },

  // 웹결제시 실패했을경우(취소,오류)
  {
    path: `${process.env.PUBLIC_URL}/fail`,
    Component: FailPayment,
  },
  {
    path: `${process.env.PUBLIC_URL}/admin/fail`,
    Component: MessageFail,
  },

  {
    path: `${process.env.PUBLIC_URL}/sales/day`,
    Component: SalesDay,
  },
  {
    path: `${process.env.PUBLIC_URL}/sales/month`,
    Component: SalesMonth,
  },
  {
    path: `${process.env.PUBLIC_URL}/receipt/:token`,
    Component: WebReceipt,
  },
  { path: `${process.env.PUBLIC_URL}/429`, Component: Error429 },
  // {
  //   path: `${process.env.PUBLIC_URL}/backoffice/lab`,
  //   Component: Lab,
  // },
];

export const v1Route = [
  {
    path: `${process.env.PUBLIC_URL}/seat/change`,
    Component: SeatChange,
  },
  {
    path: `${process.env.PUBLIC_URL}/locker/change`,
    Component: LockerChange,
  },
  {
    path: `${process.env.PUBLIC_URL}/coupon`,
    Component: Coupon,
  },
];

export const v2Route = [
  {
    path: `${process.env.PUBLIC_URL}/seat/change`,
    Component: SeatChangeV2,
  },
  {
    path: `${process.env.PUBLIC_URL}/locker/change`,
    Component: LockerChangeV2,
  },
  {
    path: `${process.env.PUBLIC_URL}/seat/category`,
    Component: SeatCategory,
  },
  {
    path: `${process.env.PUBLIC_URL}/coupon`,
    Component: CouponV2,
  },
  {
    path: `${process.env.PUBLIC_URL}/app/merchant`,
    Component: AppMerchantInfo,
  },
  {
    path: `${process.env.PUBLIC_URL}/app/review`,
    Component: AppReviewManage,
  },
  {
    path: `${process.env.PUBLIC_URL}/app/community`,
    Component: AppCommunityManage,
  },
  {
    path: `${process.env.PUBLIC_URL}/app/community/:communityPostId`,
    Component: AppCommunityPostDetail,
  },
  {
    path: `${process.env.PUBLIC_URL}/app/banner`,
    Component: AppBannerManage,
  },
  // {
  //   path: `${process.env.PUBLIC_URL}/backoffice/lab`,
  //   Component: Lab,
  // },
];

export const merchantUserRoute = [
  // user
  { path: `${process.env.PUBLIC_URL}/dashboard`, Component: Dashboard },
  {
    path: `${process.env.PUBLIC_URL}/user/ticket/info`,
    Component: UserTicketInfo,
  },
  {
    path: `${process.env.PUBLIC_URL}/user/ticket/buy`,
    Component: UserTicketBuy,
  },
  {
    path: `${process.env.PUBLIC_URL}/user/ticket/locker`,
    Component: UserLockerBuy,
  },
  {
    path: `${process.env.PUBLIC_URL}/user/user-info`,
    Component: UserInfo,
  },
  {
    path: `${process.env.PUBLIC_URL}/user/payment-info`,
    Component: UserPaymentInfo,
  },
  {
    path: `${process.env.PUBLIC_URL}/user/seat/list`,
    Component: UserSeatList,
  },
  {
    path: `${process.env.PUBLIC_URL}/user/info`,
    Component: User,
  },
  {
    path: `${process.env.PUBLIC_URL}/user/seminar/info`,
    Component: UserSeminarInfo,
  },
  {
    path: `${process.env.PUBLIC_URL}/user/seminar/buy`,
    Component: UserSeminarBuy,
  },
  {
    path: `${process.env.PUBLIC_URL}/user/mileage`,
    Component: UserMileage,
  },
  {
    path: `${process.env.PUBLIC_URL}/user/coupon`,
    Component: Usercoupon,
  },
  {
    path: `${process.env.PUBLIC_URL}/user/payment-result/:statusOrTransactionId/:ticketType`,
    Component: PaymentResult,
  },
  {
    path: `${process.env.PUBLIC_URL}/user/payment-result/:statusOrTransactionId`,
    Component: PaymentResult,
  },
];

export const userRoute = [
  { path: `${process.env.PUBLIC_URL}/select-merchant`, Component: SelectMerchant },
];

/**
 * SEO/크롤링 전용 라우트
 * - 검색 엔진이 약관 내용을 크롤링할 수 있도록 제공하는 페이지
 * - 실제 서비스에서는 API로 약관을 조회하여 모달로 표시
 * - 토큰이 없을 때만 접근 가능 (index.tsx 참조)
 */
export const termsRoute = [
  {
    path: `${process.env.PUBLIC_URL}/auth/terms/1`,
    Component: ServiceRule,
  },
  {
    path: `${process.env.PUBLIC_URL}/auth/terms/2`,
    Component: UseRule,
  },
  {
    path: `${process.env.PUBLIC_URL}/auth/terms/3`,
    Component: InformationAgreement,
  },
  {
    path: `${process.env.PUBLIC_URL}/auth/terms/4`,
    Component: MarketingAgreement,
  },
];
